import { _t } from './i18n';
import httpDriver from './httpDriver';
import {
  constants as localStorageConstants,
  getAccessTokenFromLocalStorage,
  getFromLocalStorage,
} from 'app/utils/localStorage';
import { toast } from 'react-toastify';
import axios from 'axios';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const checkImageValid = async (imageURL: string) => {
  try {
    const res = await axios.get(imageURL);
    return res;
  } catch (error) {
    console.error(error);
  }
};
export async function blobToBase64(file: File): Promise<unknown> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
}

export const getBase64 = (url: string): Promise<unknown> =>
  fetch(url, {
    method: 'get',
    headers: {
      'Content-Type': 'image/jpeg',
      mode: 'cors',
      'Access-Control-Allow-Origin': '*',
    },
  })
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(null);
          reader.readAsDataURL(blob);
        })
    );

export const uploadImage = async (image: File): Promise<{ data: string }> => {
  const imgToBase64 = await blobToBase64(image);
  const token = getAccessTokenFromLocalStorage();
  const lng = getFromLocalStorage(localStorageConstants.language);
  const res = await httpDriver({
    url: '/settings/upload-image',
    method: 'POST',
    headers: {
      skipAuthRefresh: true,
      Authorization: `bearToken ${token}`,
      'Accept-Language': lng,
    },
    data: { image_content: imgToBase64 },
  });
  return res.data;
};
///
export const uploadFile: (file: File) => any = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const token = getAccessTokenFromLocalStorage();
  const lng = getFromLocalStorage(localStorageConstants.language);

  const res = await httpDriver({
    url: '/settings/upload-file',
    method: 'POST',
    headers: {
      skipAuthRefresh: true,
      Authorization: `bearToken ${token}`,
      'Accept-Language': lng,
    },
    data: formData,
  });

  return res.data?.data;
};

export const uploadMultipleFile: (files: File[], name?: string) => any = async (
  files,
  name
) => {
  const formData = new FormData();
  for (const key in files) {
    const element = files[key];
    formData.append('files', element);
  }
  formData.append('file_name', `'${name}'`);

  const token = getAccessTokenFromLocalStorage();
  const lng = getFromLocalStorage(localStorageConstants.language);

  const res = await httpDriver({
    url: '/settings/files/zip/upload',
    method: 'POST',
    headers: {
      skipAuthRefresh: true,
      Authorization: `bearToken ${token}`,
      'Accept-Language': lng,
    },
    data: formData,
  });

  return res.data?.payload?.records;
};
{
  /*
   @params key , values 
   @return str;
        imgRes is a variable for storing the path from the backend in case the user change the pic input otherwise will store the old value in it
        onChange our picture input , we store a file type inside it ,in this case "user upload img in add or update mode"
         we check if the img url value change from string to file type , then we must upload the file then store the path inside our variable
  */
}

export const handleUploadImage = async (
  values: Record<string, any>,
  key: string
): Promise<string> => {
  let imgRes = '';
  if (values[key] && values[key].length === undefined) {
    imgRes = (await uploadImage(values[key])).data;
  } else {
    imgRes = values[key];
  }
  return imgRes;
};

export const isImgValid = async (imgObject: File): Promise<boolean> => {
  const extension = imgObject?.name
    .substring(imgObject?.name.lastIndexOf('.') + 1)
    .toLowerCase();

  if (!['png', 'jpeg', 'jpg', 'svg'].includes(extension)) {
    toast.error(_t('basic:img_notvalid_ext'));
    return Promise.reject();
  }

  // MAXIMUM ACCEPTED SIZE IS 2.1MB
  const size = (imgObject.size / 1024 / 1024)?.toFixed(2); //MB
  if (+size > 2) {
    toast.error(_t('basic:img_notvalid_size'));
    return Promise.reject();
  }
  //check image width & hight
  const img = new Image();
  img.src = window.URL.createObjectURL(imgObject);
  await img.decode();
  const { width, height } = img;
  if (width > 1000 && height > 1000) {
    toast.error(_t('basic:img_notValid_width_or_height'));
    return Promise.reject();
  }
  return true;
};
